"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cloneDeep = _interopRequireDefault(require("lodash-es/cloneDeep"));

var _isEqual = _interopRequireDefault(require("lodash-es/isEqual"));

var _utils = require("../lib/utils");

var _filterButtonUtils = require("../lib/filterButtonUtils");

var _form = _interopRequireDefault(require("../form/form"));

var _input = _interopRequireDefault(require("../input/input"));

var _formGroup = _interopRequireDefault(require("../formGroup/formGroup"));

var _popover = _interopRequireDefault(require("../popover/popover"));

var _button = _interopRequireDefault(require("../button/button"));

require("./filterButton.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FilterButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(FilterButton, _Component);

  var _super = _createSuper(FilterButton);

  function FilterButton(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FilterButton);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentMouseDown", function (_ref) {
      var target = _ref.target;
      var onClose = _this.props.onClose;
      var nodeList = document.getElementsByClassName("filter-button-modal-popover")[0];

      if (target.getClientRects().length && nodeList && !nodeList.contains(target)) {
        _this.setState({
          togglePopOver: false
        }, function () {
          if ((0, _utils.isFunction)(onClose)) {
            onClose();
          }
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentKeyUp", function (e) {
      var onClose = _this.props.onClose;

      if (e.key === "Escape") {
        _this.setState({
          togglePopOver: false
        }, function () {
          if ((0, _utils.isFunction)(onClose)) {
            onClose();
          }
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addCloseEvents", function () {
      document.addEventListener("mousedown", _this.onDocumentMouseDown);
      document.addEventListener("keyup", _this.onDocumentKeyUp);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeCloseEvents", function () {
      document.removeEventListener("mousedown", _this.onDocumentMouseDown);
      document.removeEventListener("keyup", _this.onDocumentKeyUp);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTogglePopOver", function () {
      var _this$props = _this.props,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;

      _this.setState(function (oldState) {
        var newToggleState = !oldState.togglePopOver;

        if (newToggleState === true) {
          _this.addCloseEvents();

          if ((0, _utils.isFunction)(onOpen)) {
            onOpen();
          }
        } else {
          _this.removeCloseEvents();

          if ((0, _utils.isFunction)(onClose)) {
            onClose();
          }
        }

        return {
          togglePopOver: newToggleState
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (newAppliedFilters) {
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          onClose = _this$props2.onClose;
      var stateAppliedFilters = _this.state.appliedFilters;
      var appliedFilters = (0, _cloneDeep["default"])(stateAppliedFilters);
      (0, _forEach["default"])(appliedFilters).call(appliedFilters, function (filter) {
        filter.value = newAppliedFilters[filter.fieldName];
      });

      _this.setState({
        appliedFilters: appliedFilters,
        togglePopOver: false
      }, function () {
        onSubmit(newAppliedFilters);

        if ((0, _utils.isFunction)(onClose)) {
          onClose();
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onButtonMouseDown", function () {
      var togglePopOver = _this.state.togglePopOver;

      if (togglePopOver) {
        _this.removeCloseEvents();
      }
    });
    _this.state = {
      togglePopOver: false,
      appliedFilters: props.filters && (0, _filterButtonUtils.combineFilters)(props) || []
    };
    return _this;
  }

  (0, _createClass2["default"])(FilterButton, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var previousAppliedFilters = (0, _filterButtonUtils.combineFilters)(this.props, this.state);
      var appliedFilters = (0, _filterButtonUtils.combineFilters)(nextProps, nextState);

      if (!(0, _isEqual["default"])(previousAppliedFilters, appliedFilters)) {
        this.setState({
          appliedFilters: appliedFilters
        });
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeCloseEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          togglePopOver = _this$state.togglePopOver,
          appliedFilters = _this$state.appliedFilters;
      var _this$props3 = this.props,
          popoverPlacement = _this$props3.popoverPlacement,
          filterTitle = _this$props3.filterTitle,
          popoverSize = _this$props3.popoverSize,
          renderFilters = _this$props3.renderFilters,
          filters = _this$props3.filters,
          validationSchema = _this$props3.validationSchema,
          tooltipGroups = _this$props3.tooltipGroups,
          onReset = _this$props3.onReset,
          shouldDisableApply = _this$props3.shouldDisableApply,
          popoverClassName = _this$props3.popoverClassName,
          className = _this$props3.className,
          dataTestId = _this$props3.dataTestId,
          ariaLabel = _this$props3.ariaLabel,
          hideFooter = _this$props3.hideFooter,
          buttonRef = _this$props3.buttonRef;
      var initialValues = (0, _filterButtonUtils.popoverDataParser)(appliedFilters);
      return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
        title: filterTitle,
        placement: popoverPlacement,
        className: (0, _utils.gatherClasses)(null, "filter-button-modal-popover", popoverClassName),
        body: function body() {
          return /*#__PURE__*/_react["default"].createElement(_form["default"], {
            withValidation: true,
            validationSchema: validationSchema,
            initialValues: initialValues,
            onSubmit: function onSubmit(value) {
              return _this2.handleSubmit(value);
            },
            renderChildren: function renderChildren(formikProps) {
              var isFormInvalid = (0, _keys["default"])(formikProps.errors).length > 0;
              return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderFilters(formikProps), !hideFooter && /*#__PURE__*/_react["default"].createElement(_formGroup["default"], {
                last: true,
                footer: true
              }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
                label: "Reset",
                className: "oui-mr-3",
                onClick: function onClick(event) {
                  formikProps.setValues((0, _filterButtonUtils.popoverDataParser)(filters));
                  formikProps.validateForm();

                  if ((0, _utils.isFunction)(onReset)) {
                    onReset(event);
                  }
                }
              }), /*#__PURE__*/_react["default"].createElement(_input["default"], {
                type: "submit",
                label: "Apply",
                disabled: (0, _utils.isFunction)(shouldDisableApply) && shouldDisableApply(formikProps, initialValues, appliedFilters) === true || isFormInvalid
              })));
            }
          });
        },
        size: popoverSize,
        isOpen: togglePopOver,
        toggle: this.handleTogglePopOver
      }, /*#__PURE__*/_react["default"].createElement(_filterButtonUtils.ToolTipWrapper, {
        appliedFilters: appliedFilters,
        onButtonMouseDown: this.onButtonMouseDown,
        togglePopOver: togglePopOver,
        tooltipGroups: tooltipGroups,
        className: className,
        ariaLabel: ariaLabel,
        dataTestId: dataTestId,
        buttonRef: buttonRef
      }));
    }
  }]);
  return FilterButton;
}(_react.Component);

FilterButton.defaultProps = {
  appliedFilters: [],
  filterTitle: "",
  popoverPlacement: "bottom-end",
  popoverSize: "sm",
  // eslint-disable-next-line react/default-props-match-prop-types
  filters: [],
  onSubmit: function onSubmit() {},
  onReset: null,
  shouldDisableApply: function shouldDisableApply() {
    return false;
  },
  className: "",
  popoverClassName: "",
  ariaLabel: "filter",
  dataTestId: "orion-filter-button",
  hideFooter: false
};
FilterButton.propTypes = {
  popoverPlacement: _propTypes["default"].string,
  filterTitle: _propTypes["default"].string,
  filters: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
      label: _propTypes["default"].string.isRequired
    })), _propTypes["default"].shape({
      value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
      label: _propTypes["default"].string.isRequired
    })]),
    fieldName: _propTypes["default"].string.isRequired,
    valueRenderer: _propTypes["default"].func
  })).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  appliedFilters: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
      label: _propTypes["default"].string.isRequired
    })), _propTypes["default"].shape({
      value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
      label: _propTypes["default"].string.isRequired
    })]),
    fieldName: _propTypes["default"].string.isRequired
  })),
  renderFilters: _propTypes["default"].func.isRequired,
  popoverSize: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
  validationSchema: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  tooltipGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    groupName: _propTypes["default"].string.isRequired,
    fields: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    groupRenderer: _propTypes["default"].func.isRequired
  })),
  onReset: _propTypes["default"].func,
  shouldDisableApply: _propTypes["default"].func,
  className: _propTypes["default"].string,
  popoverClassName: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  hideFooter: _propTypes["default"].bool,
  buttonRef: _propTypes["default"].object
};
FilterButton.displayName = "OrionFilterButton";
var _default = FilterButton;
exports["default"] = _default;